import { defineMessages } from "react-intl";

const baseId = "t.pages.Admin.Welcome.";

export default defineMessages({
  pageTitle: {
    id: baseId + "pageTitle",
    defaultMessage: "ADMIN WELCOME",
  },
  backToHomepage: {
    id: baseId + "backToHomepage",
    defaultMessage: "Back to Homepage",
  },
  panelTitleConsoleAdmin: {
    id: baseId + "panelTitleConsoleAdmin",
    defaultMessage: "Console Admin",
  },
  usersManagement: {
    id: baseId + "list.usersManagement",
    defaultMessage: "USERS MANAGEMENT",
  },
  applicationsAbilitationsManagement: {
    id: baseId + "list.applicationsAbilitationsManagement",
    defaultMessage: "APPLICATIONS ABILITATIONS MANAGEMENT",
  },
  temporaryAbilitationsManagement: {
    id: baseId + "list.temporaryAbilitationsManagement",
    defaultMessage: "TEMPORARY ABILITATIONS MANAGEMENT",
  },
  catalogManagement: {
    id: baseId + "list.catalogManagement",
    defaultMessage: "CATALOG MANAGEMENT",
  },
  passwordManagement: {
    id: baseId + "list.passwordManagement",
    defaultMessage: "PASSWORD MANAGEMENT",
  },
  externalPortalManagement: {
    id: baseId + "list.externalPortalManagement",
    defaultMessage: "EXTERNAL PORTAL MANAGEMENT",
  },
  SODManagement: {
    id: baseId + "list.SODManagement",
    defaultMessage: "SOD MANAGEMENT",
  },
  serviceRequestManagement: {
    id: baseId + "list.serviceRequestManagement",
    defaultMessage: "SERVICE REQUEST MANAGEMENT",
  },
  manualsManagement: {
    id: baseId + "list.manualsManagement",
    defaultMessage: "MANUALS MANAGEMENT",
  },
  reportManagement: {
    id: baseId + "list.reportManagement",
    defaultMessage: "REPORT MANAGEMENT",
  },
  templateMailManagement: {
    id: baseId + "list.templateMailManagement",
    defaultMessage: "TEMPLATE MAIL MANAGEMENT",
  },
  templateSmsManagement: {
    id: baseId + "list.templateSmsManagement",
    defaultMessage: "TEMPLATE SMS MANAGEMENT",
  },
  workflowManagement: {
    id: baseId + "list.workflowManagement",
    defaultMessage: "WORKFLOW MANAGEMENT",
  },
  tablesConfigurationManagement: {
    id: baseId + "list.tablesConfigurationManagement",
    defaultMessage: "TABLES CONFIGURATION MANAGEMENT",
  },
  recoveryPointManagement: {
    id: baseId + "list.recoveryPointManagement",
    defaultMessage: "RECOVERY POINT MANAGEMENT",
  },
  profilesManagement: {
    id: baseId + "list.profilesManagement",
    defaultMessage: "PROFILES MANAGEMENT",
  },
  certificationConfigurationsManagement: {
    id: baseId + "list.certificationConfigurationsManagement",
    defaultMessage: "CERTIFICATION CONFIGURATIONS MANAGEMENT",
  },
  createCertification: {
    id: baseId + "list.createCertification",
    defaultMessage: "CREATE CERTIFICATION",
  },
  auditManagement: {
    id: baseId + "list.auditManagement",
    defaultMessage: "AUDIT MANAGEMENT",
  },
  notifyAdmin: {
    id: baseId + "list.notifyAdmin",
    defaultMessage: "NOTIFY MANAGEMENT",
  },
  adminBRManagement: {
    id: baseId + "list.adminBRManagement",
    defaultMessage: "BUSINESS ROLE MANAGEMENT",
  },
  uigpManagement: {
    id: baseId + "list.uigpManagement",
    defaultMessage: "UIGP MANAGEMENT",
  },
  csvManagement: {
    id: baseId + "list.csvManagement",
    defaultMessage: "CSV MANAGEMENT",
  },
  technicalUsersManagement: {
    id: baseId + "list.technicalUsersManagement",
    defaultMessage: "TECHNICAL USERS MANAGEMENT",
  },
});
